import React from 'react';
import { useDispatch } from 'react-redux';
import { showToast } from '../../../helpers/toastHelper';

import OvalContentsIndex from './OvalContentsIndex';

const WrappedOvalContentsIndex = props => {
  const dispatch = useDispatch();

  return <OvalContentsIndex {...props} showToast={showToast(dispatch)} />;
};

export default WrappedOvalContentsIndex;



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_openscap-5.2.2-2.fm3_3.el8.noarch/usr/share/gems/gems/foreman_openscap-5.2.2/webpack/routes/OvalContents/OvalContentsIndex/index.js